import * as v from 'valibot';
import { IdSchema, UserIdSchema, ResourceTypeSchema, TimestampSchema } from './common.js';
export const AuditActionSchema = v.picklist([
    'login',
    /** Magic-link verify failed (expired, reused, invalid, wrong invite type, etc.). */
    'login_attempt',
    /** User requested a sign-in email (magic link issued). */
    'login_magic_link_sent',
    'logout',
    'room_created',
    'room_updated',
    'room_deleted',
    'room_entered',
    'folder_created',
    'folder_updated',
    'folder_deleted',
    'folder_renumbered',
    'file_uploaded',
    'file_updated',
    'file_viewed',
    'file_downloaded',
    'folder_downloaded',
    'file_restored',
    'file_deleted',
    'permission_granted',
    'permission_revoked',
    'invite_created',
    'invite_redeemed',
    'group_created',
    'group_updated',
    'group_deleted',
    'user_deactivated',
    'user_reactivated',
    'agent_executed',
    'agent_plan_created'
]);
export const AuditLogSchema = v.object({
    id: IdSchema,
    timestamp: TimestampSchema,
    actorId: v.optional(UserIdSchema),
    actorType: v.picklist(['user', 'agent']),
    action: AuditActionSchema,
    resourceType: v.optional(ResourceTypeSchema),
    resourceId: v.optional(IdSchema),
    roomId: v.optional(IdSchema),
    metadata: v.optional(v.record(v.string(), v.unknown())),
    ipAddress: v.optional(v.pipe(v.string(), v.ipv4())),
    traceId: v.optional(v.pipe(v.string(), v.minLength(1)))
});
export const ActivityQuerySchema = v.object({
    roomId: v.optional(IdSchema),
    userId: v.optional(UserIdSchema),
    action: v.optional(AuditActionSchema),
    since: v.optional(TimestampSchema),
    until: v.optional(TimestampSchema),
    /** Opaque cursor from the previous page's `nextCursor` (keyset pagination). */
    cursor: v.optional(v.pipe(v.string(), v.minLength(1))),
    limit: v.optional(v.pipe(v.string(), v.transform((s) => Number(s)), v.number(), v.integer(), v.minValue(1), v.maxValue(1000)), '100')
});
const AuditCursorPayloadSchema = v.object({
    t: v.pipe(v.number(), v.integer(), v.minValue(0)),
    id: IdSchema
});
function utf8ToBase64Url(json) {
    const bytes = new TextEncoder().encode(json);
    let binary = '';
    for (const b of bytes)
        binary += String.fromCharCode(b);
    return btoa(binary)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}
function base64UrlToUtf8(token) {
    const pad = token.length % 4 === 0 ? '' : '='.repeat(4 - (token.length % 4));
    const binary = atob(token.replace(/-/g, '+').replace(/_/g, '/') + pad);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++)
        bytes[i] = binary.charCodeAt(i);
    return new TextDecoder().decode(bytes);
}
/** Encode the last row on a page as the cursor for the next page (older rows). */
export function encodeAuditCursor(row) {
    const t = row.timestamp instanceof Date
        ? row.timestamp.getTime()
        : Number(row.timestamp);
    const payload = JSON.stringify({ t, id: row.id });
    return utf8ToBase64Url(payload);
}
/** Decode a cursor from the query string; throws `INVALID_CURSOR` if malformed. */
export function decodeAuditCursor(token) {
    try {
        const raw = base64UrlToUtf8(token);
        const parsed = JSON.parse(raw);
        return v.parse(AuditCursorPayloadSchema, parsed);
    }
    catch {
        throw new Error('INVALID_CURSOR');
    }
}
//# sourceMappingURL=audit.js.map